<template>
	<div class="app-metric--distribution">
		<dt class="heavy" v-html="title"/>
		<dd v-if="data.total" class="app-metric--distribution__stats">
			<dl class="app-metric--distribution__stats__data">
				<div class="app-metric--distribution__stats__data__total">
					<dt>Total</dt>
					<dd v-html="data.total"/>
				</div>
				<div class="app-metric--distribution__stats__data__percent">
					<dt>Percentage</dt>
					<dd>
						{{ data.distribution.percent.withSymbol }}
					</dd>
				</div>
			</dl>
		</dd>
		<AppDistributionBar :data="data.distribution" class="app-metric--distribution__stats__bar"/>
	</div>
</template>
<script>
import AppDistributionBar from "@/components/AppDistributionBar.vue";
import AppMetricPercent from "@/components/AppMetricPercent.vue";

export default {
	name: "AppMetricDistribution",

	components: {
		AppMetricPercent,
		AppDistributionBar,
	},

	props: {
		title: {
			type: String,
			required: false,
			default() {
				return null;
			},
		},
		data: {
			required: true,
			type: Object,
		},
		round: {
			required: false,
			default() {
				return 0;
			},
		},
	},
};
</script>
